import { IAuthenticationProvider } from '@/models/authentication/authentication-provider';
import { LoggedInUser } from '@/models/authentication/logged-in-user';
import { Credentials } from '@/models/login/credentials';
import { SessionStorage } from '@/models/storages/session-storage-factory';
import { isNull } from '@/shared/utils/utils';
import { HttpService } from './http-service';


class AuthenticationService extends HttpService implements IAuthenticationProvider {
    protected getResourceUrl(): string { return 'api/login'; }

    readonly SessionUserKey = 'auth_user';
    readonly SessionTokenKey = 'auth_token';

    get isAuthenticated(): boolean { return !isNull(this.user); }

    get user(): LoggedInUser { return SessionStorage.get(this.SessionUserKey); }
    set user(user: LoggedInUser) { SessionStorage.set(this.SessionUserKey, user); }

    get token(): any { return SessionStorage.get(this.SessionTokenKey); }

    logIn(credentials: Credentials): Promise<LoggedInUser> {
        return this.post<any>({ data: credentials })
            .then((user) => {
                SessionStorage.set(this.SessionUserKey, user);
                SessionStorage.set(this.SessionTokenKey, user.token);

                return this.user;
            })
    }

    logOut(): Promise<any> {
        SessionStorage.delete(this.SessionUserKey)
        SessionStorage.delete(this.SessionTokenKey)

        return Promise.resolve()
    }

    isAuthorized(role: string): boolean {
        return !isNull(this.user) && this.user.role === role;
    }
}

export const authService = new AuthenticationService();
